import PhotoSwipeLightbox from 'photoswipe/lightbox';

export function initPhotoSwipe() {
	const lightbox = new PhotoSwipeLightbox({
		gallery: '[data-pswp-gallery]',
		children: 'a',
		pswpModule: () => import('photoswipe'),
		// Basic options
		showHideAnimationType: 'fade',
		bgOpacity: 0.9,
		spacing: 0.1,
		allowPanToNext: false,
		zoom: true,
		// UI options
		arrowKeys: true,
		returnFocus: true,
		closeTitle: 'Close (Esc)',
		zoomTitle: 'Zoom',
		arrowPrevTitle: 'Previous (arrow left)',
		arrowNextTitle: 'Next (arrow right)',
		errorMsg: 'The image could not be loaded.',
	});

	// Handle clicking on overlay to open gallery at fourth image
	lightbox.on('itemData', (e) => {
		const { itemData } = e;
		
		// Add caption if available
		const imgElement = itemData.element.querySelector('img');
		if (imgElement && imgElement.alt) {
			itemData.alt = imgElement.alt;
		}
	});

	lightbox.init();
}
